import { BehaviorSubject } from 'rxjs'

export function subjectArrayToArray<T>(
	arr: Array<BehaviorSubject<T>>
): BehaviorSubject<T[]> {
	const subject = new BehaviorSubject(arr.map(s => s.getValue()))
	arr.map((a, i) => {
		a.subscribe({
			next: value => {
				const original = [...subject.getValue()]
				original[i] = value
				subject.next(original)
			}
		})
	})
	return subject
}



// WEBPACK FOOTER //
// ./src/utils.ts